import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-tracking-reward-consequence',
  templateUrl: './tracking-reward-consequence.component.html',
  styleUrls: ['./tracking-reward-consequence.component.scss'],
})
export class TrackingRewardConsequenceComponent {
  @Input() trackingReward: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Input() rewardTypes: any;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  initConsequenceObject(): void {
    console.log(this.trackingReward);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$TrackingReward',
    };
    if (this.trackingReward) {
      this.trackingReward.push(tmpObj);
    } else {
      this.trackingReward = [];
      this.trackingReward.push(tmpObj);
    }
    console.log(this.trackingReward);
  }

  updateConsequences() {
    this.debouncer.next(this.trackingReward);
  }

  removeConsequence(consequence) {
    this.trackingReward.splice(this.trackingReward.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
